import { Badge, type BadgeTone } from '@tb/ui';
import type { IconName } from '@tb/ui';
import type { VersionStatus } from '@tb/shared';
import { useT } from '../i18n/LocaleProvider';

const PRESENTATION: Record<VersionStatus, { tone: BadgeTone; icon: IconName }> = {
  DRAFT: { tone: 'neutral', icon: 'edit' },
  BUILDING: { tone: 'pending', icon: 'spinner' },
  BUILT: { tone: 'accent', icon: 'shield' },
  PUBLISHING: { tone: 'pending', icon: 'clock' },
  LIVE: { tone: 'live', icon: 'success' },
  FAILED: { tone: 'failed', icon: 'error' },
  SUPERSEDED: { tone: 'neutral', icon: 'history' },
};

export function StatusBadge({ status }: { status: VersionStatus }) {
  const t = useT();
  const presentation = PRESENTATION[status];
  return (
    <Badge tone={presentation.tone} icon={presentation.icon}>
      {t(`status.${status}`)}
    </Badge>
  );
}
